/**
* @ngdoc directive
* @name Right click
*
* @description
  Do something on right click (context menu)
*
* @example
  <div right-click='alert("right clicked")'>Make right click for alert</div>
*/

app.directive('rightClick', ["$parse", function($parse) {
  return function(scope, element, attrs) {
    var fn = $parse(attrs.rightClick);
    element.bind('contextmenu', function(event) {
      scope.$apply(function() {
        event.preventDefault();
        fn(scope, {$event:event});
      });
    });
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/rightClickDirective.js